import React from 'react';

import style from './loader.module.scss';

const Loader = ({ cStyles }) => {
  return (
    <div className={style.loaderClass} style={cStyles}>
      <span
        className={`${style.spinner} ${style.spinnerLarge} ${style.spinnerBlue} ${style.spinnerFast}`}
      ></span>
    </div>
  );
};

export default Loader;
